export const labelsCellScopeStyle = (fontSize = '10px', translateYValue = '1') => ({
  '& .labels-cell-scope': {
    display: 'inline-block',
    fontFamily: 'MsAds MDL2 Assets',
    fontSize,
    marginRight: '4px',
    transform: `translateY(${translateYValue}px)`,
  },
  '& .labels-cell-mcc': {
    '&::before': {
      content: '"\\ECA6"',
    },
  },
  '& .labels-cell-account': {
    '&::before': {
      content: '"\\EFBE"',
    },
  },
});

export const labelsCellItemStyle = () => ({
  '& .labels-cell-item': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    height: '20px',
    width: '70px',
    padding: '1px 7px 3px 8px',
    borderRadius: '2px',
    display: 'inline-block',
    margin: '0 10px 5px 0',
    verticalAlign: 'top',

    ...labelsCellScopeStyle(),
  },
});
